import { BitfStrapiModel } from '@common/libs/bitforce/core/models';

export class Setting extends BitfStrapiModel {
  vatPercentage: number;
  requestForDeedOfOriginGrossPrice: number;
  requestForDeedOfOriginAverageCostNetPrice: number;
  extraCasaDocPercentage: number;
  agencyExtraPercentage: number;
  revenueStamp: number;
  technicalReportAverageNetPrice: number;
  technicalReportGrossPrice?: number;
  apeGrossPrice?: number;
  technicalReportGrossPriceForSurveyor?: number;
  apeGrossPriceForSurveyor?: number;

  constructor(data: Partial<Setting> = {}) {
    super({ data });
  }

  get serialised() {
    return {
      id: this.id,
      documentId: this.documentId,
      vatPercentage: this.vatPercentage,
      requestForDeedOfOriginGrossPrice: this.requestForDeedOfOriginGrossPrice,
      requestForDeedOfOriginAverageCostNetPrice: this.requestForDeedOfOriginAverageCostNetPrice,
      extraCasaDocPercentage: this.extraCasaDocPercentage,
      agencyExtraPercentage: this.agencyExtraPercentage,
      revenueStamp: this.revenueStamp,
      technicalReportAverageNetPrice: this.technicalReportAverageNetPrice,
      technicalReportGrossPrice: this.technicalReportGrossPrice,
      apeGrossPrice: this.apeGrossPrice,
    };
  }
}
